import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface DialogActionsProps {
  children: ReactNode;
  style?: React.CSSProperties;
}

const DialogActions: React.FC<DialogActionsProps> = ({ children, style }) => {
  return <Actions style={style}>{children}</Actions>;
};

export default DialogActions;

const Actions = styled.div`
  padding: 30px 0 20px;
  box-sizing: border-box;

  display: flex;
  justify-content: center;
  gap: 8px;

  // border-top: 1px solid #e0e0e0;
`;
